import React, { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import zhCN from "antd/es/locale/zh_CN";
import { DownloadPanel, DownloadState, UploadFileState, UploadPanel, useDownloadService, useUploadService } from 'tncet-common';
import '@/global/styles/common.less';
import { SideStatus, useSideService } from "./global/store/side-store";
import { TabStatus, useTabService } from './global/store/tab-store';
import { SystemStatus, useSystemService } from './global/store/system-store';
import { TnEngineContext, TnEngineExtraContext } from 'pytha';
import { graphicStore } from './global/store/graphic-store';
import { CommonTabbarState, useCommonTabbarService } from './global/components/common-tabbar';
import { checkFileExists, getFileUploadUrl, getFileUrl } from './api/project-manage/file';
import ProjectMain from "@/layout/main";
import ProjectListMain from "@/layout/project-list";
import LargeScreenMain from "@/layout/display";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import '@/global/styles/table.less';
import '@/global/styles/modal.less';
import DesktopMain from '@/layout/desktop';
import LoginMain from './layout/login';
import { getUsersCheckLogin } from './api/lib/user';
import { User } from './global/interface/project-manage/user';
import localStore, { LOCAL_USER_TYPE, PROJECT_LIST, USER_DETAIL } from './global/store/local-store';
import CryptoJS from 'crypto-js';

export const SystemContext = React.createContext<SystemStatus>(null);
export const UploadFileContext = React.createContext<UploadFileState>(null);
export const DownloadContext = React.createContext<DownloadState>(null);
export const TabContext = React.createContext<TabStatus>(null);
export const SideContext = React.createContext<SideStatus>(null);
export const CommonTabbarContext = React.createContext<CommonTabbarState>(null);

function App() {
    const navigate = useNavigate();
    const systemContext = useSystemService();

    if (graphicStore.context == null) {
        graphicStore.context = TnEngineContext.getInstance();
    }

    if (graphicStore.extraContext == null) {
        graphicStore.extraContext = TnEngineExtraContext.getInstance();
    }


    useEffect(() => {
        let timer$ = setInterval(() => {
            checkLogin();
        }, 60000)
        return (() => {
            clearInterval(timer$);
        })
    }, [])

    const checkLogin = () => {
        if (!localStore.userId) return;
        getUsersCheckLogin().then(res => {
            if (res.status === 200) {
                let user: User = res.data;
                localStore.userId = user?.id;
                localStore.userUuid = user?.uuid;
                localStore.name = user?.name || '';
                localStore.set(LOCAL_USER_TYPE, CryptoJS.MD5(user?.type?.toString()).toString());
                localStore.set(PROJECT_LIST, user?.projectIds || []);
            }
        }).catch(err => {
            localStore.clear();
            navigate("/login");
        })
    }

    return (
        <ConfigProvider
            locale={zhCN}
            theme={{
                components: {
                    Radio: {
                        dotSize: 10,
                        radioSize: 14,
                        buttonPaddingInline: 8,
                        wrapperMarginInlineEnd: 4,
                    },
                },
            }}
        >
            <CommonTabbarContext.Provider value={useCommonTabbarService()}>
                <SystemContext.Provider value={systemContext}>
                    <UploadFileContext.Provider value={useUploadService()}>
                        <DownloadContext.Provider value={useDownloadService()}>
                            <TabContext.Provider value={useTabService()}>
                                <SideContext.Provider value={useSideService()}>
                                    <div className='tn-base'>
                                        <Routes>
                                            <Route path='/screen/project/:projectId/*' element={<LargeScreenMain />} />
                                            <Route path='/bim/project/:projectId/*' element={<ProjectMain />} />
                                            <Route path='/bim/project/*' element={<ProjectMain />} />
                                            <Route path='/desktop/*' element={<DesktopMain />} />
                                            <Route path='/login' element={<LoginMain />} />
                                            <Route path='*' element={<Navigate to="/login" />} />
                                        </Routes>
                                    </div>
                                    <div className='upload-download-panel'>
                                        <UploadPanel checkFileExists={checkFileExists} getUploadUrl={getFileUploadUrl} uploadContext={UploadFileContext} />
                                        <DownloadPanel downloadContext={DownloadContext} getFileUrl={getFileUrl} />
                                    </div>
                                </SideContext.Provider>
                            </TabContext.Provider>
                        </DownloadContext.Provider>
                    </UploadFileContext.Provider>
                </SystemContext.Provider>
            </CommonTabbarContext.Provider>
        </ConfigProvider>
    );
}

export default App;
